module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funreport-title"
  }, [_c('div', {
    staticClass: "fromWhom"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.selfResult.avatar
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "animal"
  }, [_c('img', {
    attrs: {
      "src": _vm.funreport.pic.replace('animal.png', 'animalNameCh.png').replace('../', './')
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "dots"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-310f9fcb!./~/._vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/funHeadShare.vue
// module id = 129
// module chunks = 2